import { TIntegrationsCoveragePerIntegrationData } from "src/data/portfolioAnalytics/types/portfolioAnalyticsTypes"

/**
 * Calculates the total number of units and linked units from integrations analytics data.
 * @param analytics - The analytics array from integrations coverage API response
 * @returns An object with totalUnits and linkedUnits
 */
export function getIntegrationsCoverageTotals(
  analytics: Array<{
    data: TIntegrationsCoveragePerIntegrationData[]
  }>
): { totalUnits: number; linkedUnits: number } {
  return analytics.reduce(
    (acc, group) => {
      const groupTotals = group.data.reduce(
        (groupAcc, integration) => {
          const { total_integration_entities, linked_homes } =
            integration.aggregation
          return {
            totalUnits: groupAcc.totalUnits + total_integration_entities,
            linkedUnits: groupAcc.linkedUnits + linked_homes,
          }
        },
        { totalUnits: 0, linkedUnits: 0 }
      )
      return {
        totalUnits: acc.totalUnits + groupTotals.totalUnits,
        linkedUnits: acc.linkedUnits + groupTotals.linkedUnits,
      }
    },
    { totalUnits: 0, linkedUnits: 0 }
  )
}
